module.exports = __webpack_public_path__ + "static/media/MessageIcon.0df3b688.svg";